import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable({
  providedIn: 'root',
})
export class CustomDatePickerAdapterService extends NativeDateAdapter {
  override getMonthNames(style: 'long' | 'short' | 'narrow'): string[] {
    const months = super.getMonthNames(style);
    return months.map(month => month.replace(/\.$/, ''));
  }
}
